var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNuls(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32769)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#82BD39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.10169 10.89L9 12.0735V14.625L5.625 13.1271V6.53569C5.625 6.43838 5.66831 6.34556 5.74425 6.28088L6.12844 5.95181C6.16545 5.9198 6.20863 5.89573 6.25531 5.88107C6.302 5.86642 6.35119 5.8615 6.39985 5.86661C6.44851 5.87172 6.49561 5.88677 6.53823 5.91081C6.58085 5.93485 6.61808 5.96737 6.64762 6.00638L9.72169 10.0361L11.4199 11.0745V5.517L9.91913 4.76831L9.846 8.25356L9.05175 7.2L9.01575 3.375L12.375 4.93819V11.4992L11.6117 12.1281L9.20756 10.7854L6.53906 7.28494L6.5025 12.6028L8.09156 13.4167L8.10169 10.89Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32769"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNuls);
export default __webpack_public_path__ + "static/media/nuls.6a0193df829c132d009374c236893630.svg";
export { ForwardRef as ReactComponent };